import { SyntheticEventData } from 'react-dom/test-utils';
import { ButtonColors, ButtonProps, ButtonSizes } from 'src/shared/design-system/Buttons';
import { FollowColors } from '../FollowToggleIcon';

export interface FollowButtonProps extends ButtonProps {
  className?: string;
  color?: ButtonProps['color'];
  followingColor?: FollowColors;
  iconOnly?: boolean;
  isAnimated?: boolean;
  isFollowing?: boolean;
  invertOnFollow?: boolean;
  name?: string;
  onClick?: (e: SyntheticEventData) => void;
  showNameOnButton?: boolean;
  showUnfollowTooltip?: boolean;
  size?: ButtonProps['size'];
}

export type FollowButtonUnfollowTooltipProps = {
  isFollowing?: FollowButtonProps['isFollowing'];
  name?: string;
};

export interface StyledButtonProps extends FollowButtonProps {
  isFollowing?: FollowButtonProps['isFollowing'];
  followingColor?: FollowButtonProps['followingColor'];
}

export const defaultButtonColor = ButtonColors.LIGHT_GRAY;
export const defaultButtonSize = ButtonSizes.M;

export { ButtonColors, ButtonSizes, FollowColors };
